import { render, staticRenderFns } from "./VersionUpdatePopup.vue?vue&type=template&id=6025e0b0"
import script from "./VersionUpdatePopup.vue?vue&type=script&lang=js"
export * from "./VersionUpdatePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6025e0b0')) {
      api.createRecord('6025e0b0', component.options)
    } else {
      api.reload('6025e0b0', component.options)
    }
    module.hot.accept("./VersionUpdatePopup.vue?vue&type=template&id=6025e0b0", function () {
      api.rerender('6025e0b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/VersionUpdatePopup.vue"
export default component.exports